import { render, staticRenderFns } from "./PayQuick.vue?vue&type=template&id=1ce96cdc&scoped=true"
import script from "./PayQuick.vue?vue&type=script&lang=js"
export * from "./PayQuick.vue?vue&type=script&lang=js"
import style0 from "./PayQuick.vue?vue&type=style&index=0&id=1ce96cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce96cdc",
  null
  
)

export default component.exports